import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  max-width: 100%;
`;

export const FileWrapper = styled.div<{ $submissionTab?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 10px;
  padding: 8px;
  border-radius: 8px;
  align-items: center;
  justify-content: space-between;

  background: ${({ $submissionTab, theme }) => ($submissionTab ? theme.palette.grey[50] : theme.palette.common.white)};
  border: ${({ $submissionTab, theme }) => ($submissionTab ? `1px solid ${theme.palette.grey[50]}` : 'none')};

  &:hover {
    border: ${({ $submissionTab, theme }) => ($submissionTab ? `1px solid ${theme.palette.grey[300]}` : 'none')};
    background: ${({ theme }) => theme.palette.common.white};
    box-shadow: ${({ $submissionTab, theme }) => ($submissionTab ? `0 8px 50px 0 ${theme.palette.grey[200]}` : 'none')};
  }
`;

export const FileNameWrapper = styled.div<{ $submissionTab?: boolean }>`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  max-width: ${({ $submissionTab }) => ($submissionTab ? '70%' : '100%')};
`;

export const FileName = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.text.primary};
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileSizeWrapper = styled.div`
  position: relative;
  display: inline-block;
  min-width: 80px;
  text-align: right;
`;

export const FileSize = styled.p<{ $submissionTab?: boolean }>`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 12px;
  font-weight: 400;
  margin: 0;
  transition: opacity 0.1s ease-in-out;

  ${FileWrapper}:hover & {
    opacity: ${({ $submissionTab }) => ($submissionTab ? 0 : 1)};
  }
`;

export const FileLink = styled.a`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 12px;
  font-weight: 400;
  text-decoration: none;
  text-align: right;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  max-width: 100%;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;

  white-space: nowrap;

  ${FileWrapper}:hover & {
    opacity: 1;
  }
`;
